import React from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';

import { translateHref } from '../../../../utils/string.js';
import { Button } from '../../../buttons.jsx';

class ItemCTA extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const link = this.props.href;
    const linkText = this.props.children || this.props.linkText;
    const target = this.props.target;
    const hrefParts = translateHref(link);
    let onClick;

    const linkModel = {
      addClasses:     'xCTA',
      target,
      href:           hrefParts.href,
      dataAttributes: {},
    };

    if (hrefParts.action) {
      _.set(linkModel, 'dataAttributes.data-ngx-action', hrefParts.action);
    }

    // Button component calls preventDefault() so we need to pass a click handler to override
    if (linkModel.href !== '#') {
      onClick = () => {
        NGX.Analytics.trigger('action:cta', { url: linkModel.href });
        window.open(linkModel.href, this.props.target);
      }
    }

    const linkMarkup = (
      <Button onClick={onClick} {...linkModel}>
        {linkText}
      </Button>
    );

    return <div className="xCTAContainer">{linkMarkup}</div>;
  }
}

ItemCTA.propTypes = {
  href:     PropTypes.string.isRequired,
  linkText: PropTypes.string,
  target:   PropTypes.string,
};

ItemCTA.defaultProps = {
  target: '_blank',
};

export default ItemCTA;
